// import ApiServices from "@/apiservices"
import {createSlice} from "@reduxjs/toolkit"
import ApiServices from "../../services/apiservices"

const initialStateValue = ApiServices.getLocalStorage("user") ? ApiServices.getLocalStorage("user") : null


export const userSlice = createSlice({
    name: "user",
    initialState:{ value:initialStateValue  },
    reducers: {
        login:(state, action)=> {
            state.value = action.payload
        },
        logout:(state)=>{
            state.value =null
            // ApiServices.handleLogout()
        }
    }
})

export default userSlice.reducer;

export const {login, logout} = userSlice.actions